import React from 'react'
import { LucideIcon } from 'lucide-react'
import { BaseState } from './BaseState'

export interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: React.ReactNode
  className?: string
}

export default function EmptyState({ 
  icon, 
  title, 
  description, 
  action,
  className = '' 
}: EmptyStateProps) {
  return (
    <BaseState
      icon={icon}
      title={title}
      description={description}
      action={action}
      className={className}
      iconClassName="text-gray-500"
      iconContainerClassName="bg-gray-100 dark:bg-gray-800"
    />
  )
}
